/* eslint-disable import/first */
import React from 'react';
import { Divider, Grid, Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Redux, Slices } from 'spwa-ui-library';

import { FutureClock } from '../../components/Icons';
import { AiOutlineClockCircle } from '@react-icons/all-files/ai/AiOutlineClockCircle';
/* eslint-disable import/first */
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
import spinner from './images/spinner.gif';
const { sendNotification } = Slices.orderSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectCountryValidations } = Slices.configSlice;
import css from './index.module.scss';
import ClassNames from 'classnames';

const OrderStatus = ({
  differenceTime,
  enableState,
  orderInfo,
  ordStatus,
  description,
  title,
  img,
  country,
  statusLoader,
  getOrderStatusDetails,
  isDesktop,
}) => {
  const dispatch = useDispatch();
  const [smsState, setSmsState] = React.useState(true);
  const [checkStatus, setCheckStatus] = React.useState('pendingConfirmation');
  const countryName = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const intl = useIntl();
  React.useEffect(() => {
    if (smsState && ordStatus === 'PENDING' && orderInfo) {
      try {
        dispatch(sendNotification({ id: orderInfo?._id }))
          .then((resp) => {})
          .catch((error) => {
            console.log(error);
          });
        setSmsState(false);
      } catch (error) {
        console.log(error);
        setSmsState(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [smsState, ordStatus, orderInfo]);
  // const sendSms = () => {};
  // eslint:fix sednSms is defined a value but is never used
  React.useEffect(() => {
    if (ordStatus === 'PENDING') {
      const heading =
        'thankYou_' +
        ordStatus +
        (orderInfo?.advanceTime !== 0 ? 'Advance' : '') +
        (orderInfo?.address?.addressSubType || '');
      setCheckStatus(heading);
    }
  }, [ordStatus, orderInfo]);

  const statusObj = {
    PENDING: (
      <Grid>
        <Grid
          className={ClassNames(
            css.pendingConfirmContainer,
            orderInfo?.advanceTime !== 0 ? css.advanceOrderStatus : ''
          )}
        >
          {enableState && differenceTime >= 0 ? (
            <>
              <Grid className={css.titlePending}>
                {orderInfo?.advanceTime !== 0 ? (
                  intl.formatMessage({ id: checkStatus })
                ) : (
                  <FormattedMessage id="status_PENDING" defaultMessage="Pending Confirmation" />
                )}
              </Grid>
              <Grid className={css.pendingLoader}>
                {<img src={spinner} className={css.spinnerImg} alt="loading" />}
              </Grid>
              {isDesktop && orderInfo?.advanceTime === 0 && orderInfo?.status === 'PENDING' && (
                <Button variant="outlined" size="small" onClick={getOrderStatusDetails}>
                  <FormattedMessage id="refresh" defaultMessage="Refresh" />
                </Button>
              )}
            </>
          ) : (
            <>
              {orderInfo?.advanceTime !== 0 ? (
                intl.formatMessage({ id: checkStatus })
              ) : (
                <Grid>
                  {' '}
                  <FormattedMessage
                    id="status_unableConfirm"
                    defaultMessage="Sorry. Unable to confirm your order status"
                  />
                </Grid>
              )}
            </>
          )}
        </Grid>
        {enableState && orderInfo?.advanceTime === 0 ? (
          <Grid className={css.pendingDescText}>
            <FormattedMessage
              id="status_waitingForRestaurant"
              defaultMessage="We are waiting for the restaurant to confirm your order"
            />
          </Grid>
        ) : (
          ''
        )}
      </Grid>
    ),
    CONFIRMED: <FormattedMessage id="status_CONFIRMED" defaultMessage="Order Confirmed" />,
    BEING_PREPARED: (
      <FormattedMessage id="status_BEING_PREPARED" defaultMessage="Order Confirmed" />
    ),
    READY: <FormattedMessage id="status_READY" defaultMessage="Order Confirmed" />,
    ON_THE_WAY: <FormattedMessage id="status_ON_THE_WAY" defaultMessage="Order Confirmed" />,
    DELIVERED: <FormattedMessage id="status_DELIVERED" defaultMessage="Order Confirmed" />,
    CLOSED: <FormattedMessage id="status_CLOSED" defaultMessage="Order Closed" />,
    CANCELED: <FormattedMessage id="status_CANCELED" defaultMessage="Oops! The Order Cancel" />,
    FAILURE: <FormattedMessage id="status_FAILURE" defaultMessage="Oops! The Order Failed" />,
    unableConfirm: (
      <FormattedMessage
        id="status_unableConfirm"
        defaultMessage="Sorry. Unable to confirm your order status"
      />
    ),
  };
  // const formatRelativeLocale = {
  //   lastWeek: 'dd MMM, yyy| hh:mm a',
  //   yesterday: 'dd MMM, yyy | hh:mm a',
  //   today: 'dd MMM, yyy | hh:mm a',
  //   tomorrow: 'dd MMM, yyy | hh:mm a',
  //   nextWeek: 'dd MMM, yyy | hh:mm a',
  //   other: 'dd MMM, yyy | hh:mm a',
  // };
  // eslint:fix formatRelativeLocale is defined a value but is never read

  // const locale = {
  //   ...enGB,
  //   formatRelative: (token) => formatRelativeLocale[token],
  // };
  // eslint:fix locale is defined a value but is never used
  var d =
    orderInfo?.advanceTime === 0
      ? new Date(orderInfo?.createdAt)
      : new Date(orderInfo?.advanceTime); /* midnight in China on April 13th */

  // console.log(d.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' }));
  const formDate = `${d.getDate()} ${d.toLocaleDateString('en-US', {
    month: 'long',
  })}, ${d.getFullYear()}`;
  return (
    <Grid className={css.root}>
      <Grid className={`${css.flexBox} ${css.marginEnd}`}>
        <Grid className={css.imgProps}>
          <img src={img} width="80" alt="" />
        </Grid>

        {(ordStatus !== 'PENDING' || ordStatus !== 'FAILURE') && (
          <Grid className={ClassNames(css.descProps)}>
            <Grid>
              <Typography className={css.title}>{statusObj[ordStatus]}</Typography>
            </Grid>
            <Grid>
              {(ordStatus === 'PENDING' && orderInfo?.advanceTime === 0) ||
              ordStatus === 'FAILURE' ? (
                ''
              ) : (
                <Grid className={css.orderNoContainer}>
                  <Typography className={css.succdesc}>
                    {orderInfo?.orderDisplayNumber ? (
                      <h5
                        className={`${css.orbNumber} ${
                          window.location.pathname.includes('order-history') ? css.smallText : ''
                        }`}
                      >
                        <FormattedMessage id={'orderdetails_orderno'} defaultMessage="Order No" />{' '}
                        <span className={css.redText}>{orderInfo?.orderDisplayNumber}</span>
                      </h5>
                    ) : null}
                  </Typography>
                </Grid>
              )}
            </Grid>
            {isDesktop ? (
              <>
                <Divider />
                <Grid className={css.orderStatusFooter}>
                  <Grid className={css.timeProps}>
                    <span>
                      <FormattedMessage id="trackorder_orderno" defaultMessage="ORDER Id." />
                      <span className={css.boldText}>{` ${country}-${orderInfo?.uOrderRef}`}</span>
                    </span>
                  </Grid>
                  <Grid className={css.timeProps}>
                    <span>
                      {orderInfo?.advanceTime ? (
                        <Grid className={css.flexBox}>
                          <AiOutlineClockCircle />
                        </Grid>
                      ) : (
                        ''
                      )}
                      <Typography>
                        <span>{orderInfo?.createdAt ? formDate : ''}</span>
                      </Typography>
                    </span>
                  </Grid>
                </Grid>
              </>
            ) : null}
          </Grid>
        )}
      </Grid>
      {!isDesktop ? (
        <>
          <Divider />
          <Grid
            style={{
              display: 'flex',
              flexDirection: 'row',
              padding: '0.3rem 0.5rem',
              borderRadius: '0.4rem',
              backgroundColor: 'rgba(225, 237, 255, 1)',
            }}
          >
            <Grid className={`${css.timeProps} ${css.borderRight}`}>
              <span>
                <FormattedMessage id="trackorder_orderno" defaultMessage="ORDER Id." />
                <span className={css.boldText}>{` ${country}-${orderInfo?.uOrderRef}`}</span>
              </span>
            </Grid>
            <Grid className={css.timeProps}>
              <span>
                {orderInfo?.advanceTime ? (
                  <Grid className={css.flexBox}>
                    <AiOutlineClockCircle />
                  </Grid>
                ) : (
                  ''
                )}
                <Typography>
                  <span>{orderInfo?.createdAt ? formDate : ''}</span>
                </Typography>
              </span>
            </Grid>
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};

export default OrderStatus;
